import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    TASKS: "Задачи",
    CLEAR: "Сбросить",
    START_METHODS: "Запустить методы",
    CREATE_SCRIPT: "Создать скрипт",
    buildSelected: (countMethods, countTasks) => `${countMethods} ${buildCorrectGrammarText(countMethods, [
        "метод",
        "метода",
        "методов"
    ])}, ${countTasks} ${buildCorrectGrammarText(countTasks, ["задача", "задачи", "задач"])}`
};
